import { render, staticRenderFns } from "./notifications-item-study-follow-up.vue?vue&type=template&id=0c013066&scoped=true"
import script from "./notifications-item-study-follow-up.vue?vue&type=script&lang=js"
export * from "./notifications-item-study-follow-up.vue?vue&type=script&lang=js"
import style0 from "./notifications-item-study-follow-up.vue?vue&type=style&index=0&id=0c013066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c013066",
  null
  
)

export default component.exports